import { render, staticRenderFns } from "./HotSell.vue?vue&type=template&id=633cdfa3&scoped=true&"
import script from "./HotSell.vue?vue&type=script&lang=js&"
export * from "./HotSell.vue?vue&type=script&lang=js&"
import style0 from "./HotSell.vue?vue&type=style&index=0&id=633cdfa3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633cdfa3",
  null
  
)

export default component.exports